import { useSelector, useDispatch } from 'react-redux';

import { Dialog } from 'primereact/dialog';
import { Media } from '../../ShowMedia/Media';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import { useGalleryContext } from '../../../Contexts/GalleryContext';

function PlaylistMediaPreview({ item }) {
  const openDialog = useSelector((state) => state.global.openDialog)
  const dispatch = useDispatch();
  const {   setSelectedItem } = useGalleryContext();

  const onclose = () => {
    dispatch(toggleDialog("playlistMediaPreview"))
    setSelectedItem("")
  }
  return (
    <>
      <Dialog visible={openDialog.playlistMediaPreview}
        onHide={onclose} draggable={false}
        breakpoints={{ '960px': '95vw' }}
        style={{ width: '40vw', minHeight: '400px' }}
        header="Playlist Media Previewer" >
        <div className="d-flex justify-content-center h-full align-items-center" style={{ minHeight: '300px' }}>
          <Media data={item} />
        </div>
      </Dialog >
    </>
  )
}

export default PlaylistMediaPreview